import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css"; // Import the CSS file
// import "../../../src/App.css";
import { IoMdCloseCircle } from "react-icons/io";
import {
  FaMobileAlt,
  FaCaretDown,
  FaUser,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa"; // Import icons
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import apiBaseUrl from "../../config/config";
import { useAuth } from "../AuthContext";

const Login = (props) => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
    site_code: apiBaseUrl.sitecodes,
    user_type: "User",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for toggling dropdown
  const [inputType, setInputType] = useState("mobile"); // State for controlling which input type is selected
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [isDisabled, setIsDisabled] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/userAuthenticate`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(formData),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 500 });
          // localStorage.setItem(
          //   "userdata",
          //   JSON.stringify(response.data.resultData)
          // );
          login(response.data.resultData);

          // setTimeout(() => {
          //   props?.togglePopup();
          //   props?.handleClose();
          // }, 1000);
          if (props?.togglePopup) {
            props.togglePopup();
          }
          if (props?.handleClose) {
            props.handleClose();
          }
        } else {
          toast.error("Invalid Credentials", { autoClose: 800 });
        }
        formData.user_name = "";
        formData.password = "";
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during login", { autoClose: 800 });
      });
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleInputTypeChange = (type) => {
    setInputType(type);
    setDropdownOpen(false); // Close dropdown after selection
    setUsername(""); // Reset username field when switching input types
  };

  // const handleLogin = (e) => {
  //   e.preventDefault();

  //   // Hardcoded credentials for testing
  //   const hardcodedUsername = 'user';
  //   const hardcodedPassword = '1234';

  //   // Check the credentials
  //   if (username === hardcodedUsername && password === hardcodedPassword) {
  //     // Store login status in localStorage
  //     localStorage.setItem('isAuthenticated', 'true');
  //     setError(''); // Clear any previous errors

  //     // Navigate to the main page after successful login
  //     navigate('/');  // Redirect to home page (or whichever route you prefer)
  //   } else {
  //     setError('Invalid username or password');  // Display an error message
  //   }
  // };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle between showing and hiding password
  };

  const handleCreateAccount = () => {
    navigate("/signup"); // Navigate to the signup page
  };

  const loginDemoID = async () => {
    setIsDisabled(true);
    // setIsLoading(true)

    var demoData = {
      user_name: "demo_247betfair",
      password: "Abcd1234",
      site_code: apiBaseUrl.sitecodes,
      user_type: "User",
    };

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/userAuthenticate`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(demoData),
    };
    axios(config)
      .then(function (response) {
        console.log(response);
        setIsDisabled(false);

        if (response.data.result != 0) {
          toast.success(response.data.resultMessage, { autoClose: 500 });

          // setIsLoading(false)
          login(response.data.resultData);

          // setTimeout(() => {
          //   props?.togglePopup();
          //   props?.handleClose();
          // }, 1000);
          if (props?.togglePopup) {
            props.togglePopup();
          }
          if (props?.handleClose) {
            props.handleClose();
          }
          // storeUserinfo(response.data.resultData);
        } else {
          // console.log('--', response.data.resultMessage)
          // errorNotification();
          toast.success(response.data.resultMessage, { autoClose: 800 });
        }
      })
      .catch(function (error) {
        setIsDisabled(false);
        console.log(error);
      });
  };

  return (
    <>
      {/* Login Button */}
      {/* <button className="pushable-login submit-btn login-trigger " onClick={togglePopup}>
        <span className="front-login">Login</span> 
      </button> */}

      {/* Popup */}
      {props?.showPopup && (
        <div
          className="login-popup-overlay"
          onClick={() => props?.togglePopup()}
        >
          <div
            className="login-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="close-btn">
              <IoMdCloseCircle onClick={() => props?.togglePopup()} />
            </span>
            <div className="login-popup-logo">
              <img className="form-logo" src="../Images/logo.png" alt="" />
            </div>
            <form className="login-form text-[#000]" onSubmit={handleSubmit}>
              {/* Dynamic label */}
              <label className="input-label-above">
                {inputType === "mobile" ? "Mobile Number" : "User ID"}
              </label>

              {/* Username Section with Dropdown */}
              <div className="username">
                <span className="input-label">
                  {inputType === "mobile" ? "+91" : "ID"}
                </span>
                <input
                  className="login-input"
                  type="text"
                  name="user_name"
                  placeholder={
                    inputType === "mobile"
                      ? "Enter mobile number"
                      : "Enter user ID"
                  }
                  required
                  value={formData.user_name}
                  onChange={(e) => handleInputChange(e)}
                />
                <span className="icon relative pr-2" onClick={toggleDropdown}>
                  <FaMobileAlt
                    size={30}
                    color="#e9b02e"
                    style={{ marginRight: 0 }}
                    className="absolute top-[-0.3rem] right-[0.5rem]"
                  />{" "}
                  <FaCaretDown
                    size={20}
                    color="#e9b02e"
                    style={{ marginRight: 0 }}
                    className="absolute top-[0.1rem]"
                  />
                </span>{" "}
                {/* Mobile icon */}
                {/* Dropdown Menu */}
                {dropdownOpen && (
                  <div className="dropdown-menu show">
                    <div onClick={() => handleInputTypeChange("mobile")}>
                      <FaMobileAlt
                        size={20}
                        color="#e9b02e"
                        style={{ marginRight: 0 }}
                      />
                      Mobile Number
                    </div>
                    <div onClick={() => handleInputTypeChange("userid")}>
                      <FaUser
                        size={20}
                        color="#e9b02e"
                        style={{ marginRight: 0 }}
                      />
                      User ID
                    </div>
                  </div>
                )}
              </div>

              <span className="password-label">Password</span>
              <div className="password">
                <input
                  className="password-input"
                  type={showPassword ? "text" : "password"} // Toggle between 'text' and 'password'
                  name="password"
                  placeholder="Password"
                  required
                  value={formData.password}
                  onChange={(e) => handleInputChange(e)}
                  style={{ width: "100%", padding: "14px", marginTop:"0px", borderRadius:"8px", height:"43px" }}
                />
                <span
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <FaEyeSlash size={20} />
                  ) : (
                    <FaEye size={20} />
                  )}
                </span>{" "}
                {/* Eye icon to toggle password visibility */}
              </div>

              <button type="submit" className=" submit-btn">
                <span className="front">Login</span>
              </button>
              <button
                type="button"
                onClick={() => loginDemoID()}
                className=" submit-btn"
                style={{ marginTop: 10 }}
                disabled={isDisabled}
              >
                <span className="front">Login With Demo ID</span>
              </button>
            </form>
            {error && <p className="error">{error}</p>}
            <span
              className=""
              style={{
                color: "#fff",
                display: "block",
                textAlign: "right",
                marginTop: "10px",
              }}
              onClick={() => props.toggleForgotPopup()}
            >
              Forgot Password
            </span>
            <span className="other-login">Or login with</span>
            <span className="other-button">
              {/* <button className="google border border-gray-500">
                <div className="flex justify-center items-center">
                  <img
                    src="./Images/google.png"
                    alt=""
                    className="google-image"
                  />
                  <span className="text-[#fff]">Google</span>
                </div>
              </button> */}
              <button
                className="whatsapp"
                onClick={() => props?.openWhatsApp(props?.whatsappNum)}
              >
                <div className="flex justify-center items-center">
                  <img
                    src="./Images/whatsapp.png"
                    alt=""
                    className="whatsapp-image"
                  />
                  <span className="text-[#fff]">WhatsApp</span>
                </div>
              </button>
            </span>
            <span
              className="new-account"
              onClick={() => props?.toggleSignUpPopup()}
            >
              New User? Create Account
            </span>{" "}
            {/* Added onClick event */}
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
